/* eslint-disable @typescript-eslint/naming-convention */

import { ResponseWithData } from '@utils/ajax';
import { get } from '.';

export type DiscordActionType =
  | 'add_user_to_guild_error'
  | 'assign_role_error'
  | 'automatic_update_nickname'
  | 'automatic_update_username'
  | 'banned'
  | 'kicked'
  | 'linked'
  | 'remove_role_error'
  | 'role_changed_admin'
  | 'unbanned'
  | 'unlinked'
  | 'role_changed';

export type DiscordLogEntry = {
  id: string;
  discordUserId: string;
  discordNickname: string;
  authorName: string | null;
  authorId: string | null;
  actionType: DiscordActionType;
  field: string;
  oldValue: string | null;
  newValue: string | null;
  reason: string;
  createdAt: string;
};

export type DiscordLogUser = {
  userId: string;
  name: string;
  source: string;
  discordUserId: string;
  discordNickname: string;
  userRole: string;
  status: 'banned' | 'kicked' | 'linked' | 'unlinked';
  updatedAt: Date;
  logCount: number;
};

export type FilterDiscordLogs = {
  pageNumber: number;
  pageSize: number;
  search?: string;
  sort?: string;
  order?: 'ASC' | 'DESC';
  source?: string[];
  userRole?: string[];
  status?: string[];
};

export type DiscordLogsResponse = {
  discordLogs: DiscordLogUser[];
  dataCount: number;
  availableSources: string[];
  availableRoles: string[];
  loading?: boolean;
};

export type DiscordLogHistoryResponse = {
  logs: DiscordLogEntry[];
  dataCount: number;
};

export type StandardResponse<T> = {
  success: boolean;
  result: T;
};

export async function getDiscordLogs(
  filters: FilterDiscordLogs
): Promise<StandardResponse<DiscordLogsResponse>> {
  const queryParams = new URLSearchParams();
  queryParams.append('pageNumber', String(filters.pageNumber));
  queryParams.append('pageSize', String(filters.pageSize));

  if (filters.search) queryParams.append('search', filters.search);
  if (filters.sort) queryParams.append('sort', filters.sort);
  if (filters.order) queryParams.append('order', filters.order);
  if (filters.source?.length) {
    queryParams.append('source', filters.source.join(','));
  }
  if (filters.userRole?.length) {
    queryParams.append('userRole', filters.userRole.join(','));
  }
  if (filters.status?.length) {
    queryParams.append('status', filters.status.join(','));
  }

  const responseWithData: Promise<
    ResponseWithData<StandardResponse<DiscordLogsResponse>>
  > = get(`/api/discord/logs?${queryParams.toString()}`);
  return responseWithData.then(res => res.data);
}

export async function getDiscordLogHistory(
  userId: string
): Promise<StandardResponse<DiscordLogHistoryResponse>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<DiscordLogHistoryResponse>>
  > = get(`/api/discord/log-history/${userId}`);
  return responseWithData.then(res => res.data);
}
